<script>
import Jobs from "@/components/jobs/Jobs.vue";
import SearchJob from "@/components/jobs/SearchJob.vue";
import SmartFit from "./smartFit.vue";
import Bioritmo from "./bioritmo.vue";
import Studios from "./studios.vue";

export default {
  name: "JobsList",
  data() {
    return {
      componentId: null,
    };
  },
  head() {
    return this.$head({
      title: "Vagas | ",
    });
  },
  watch: {
    "$route.params.group": function (group) {
      this.getGroup();
    },
  },
  mounted() {
    this.getGroup();
  },
  methods: {
    getGroup() {
      if (this.group == "smart-fit") {
        this.componentId = "SmartFit";
      }
      if (this.group == "bioritmo") {
        this.componentId = "Bioritmo";
      }
      if (this.group == "studios") {
        this.componentId = "Studios";
      }
      if (this.group == "corporativas") {
        this.componentId = "Corporativas";
      }
    },
  },
  props: {
    group: null,
  },
  components: {
    Jobs,
    SearchJob,
    SmartFit,
    Bioritmo,
    Studios,
  },
};
</script>

<template>
  <div class="jobs-group">
    <div class="banner mb-5" :class="group || 'smart-fit'">
      <img
        v-if="componentId == 'SmartFit'"
        src="@/assets/images/smart_fit/smart-fit-logoc.png"
        alt=""
      />
      <img
        v-if="componentId == 'Bioritmo'"
        src="@/assets/images/smart_fit/bioritmow.png"
        alt=""
      />
      <h1 v-if="componentId == 'Studios'">
        <i>STUDIOS</i>
      </h1>
      <h1 v-if="componentId == 'Corporativas'">
        <i>Vagas corporativas</i>
      </h1>
    </div>
    <component :class="{'mt-5,mt-lg-0':componentId == 'Corporativas'}" :is="componentId"></component>
    <Jobs />
  </div>
</template>


<style lang="scss" scoped>
.jobs-group {
  .banner {
    width: 100%;
    height: 70vh;
    &.smart-fit {
      background: url(../../assets/images/smart_fit/jobs1.jpg) no-repeat center
        center;
      background-size: cover;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        position: relative;
        z-index: 99;
        width: 70%;
        max-width: 400px;
      }
      &::after {
        content: "";
        left: 0;
        top: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: rgba(#000, 0);
      }
    }
    &.bioritmo {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      background-image: url(../../assets/images/smart_fit/vaga_bio.jpg);
      background-size: cover;
      background-position: 0 -100px;
      img {
        position: relative;
        z-index: 99;
        width: 70%;
        max-width: 400px;
      }
      &::after {
        content: "";
        left: 0;
        top: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: rgba(#000, 0);
      }
    }
    &.corporativas {
      background: url(../../assets/images/smart_fit/job2.jpg) no-repeat center
        center;
      background-size: cover;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 4rem;
      h1 {
        color: #fff;
        z-index: 99;
        font-size: 4rem;
      }
      img {
        position: relative;
        z-index: 99;
        width: 70%;
        max-width: 400px;
      }
      &::after {
        content: "";
        left: 0;
        top: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: rgba(#000, 0.2);
      }
    }
    &.studios {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      background-image: url(../../assets/images/smart_fit/studio.jpg);
      background-size: cover;
      h1 {
        color: #fff;
        z-index: 99;
        font-size: 6rem;
      }
      img {
        position: relative;
        z-index: 99;
        width: 70%;
        max-width: 400px;
      }
      &::after {
        content: "";
        left: 0;
        top: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: rgba(#000, 0.5);
      }
    }
  }
}
</style>